import axios from "@/api/restApi"

export default {
  /// 옵션 상품 목록 조회
  async getOptionProducts({ type, keyword } = {}) {
    const res = await axios.get("/api/option-products/select", {
      params: { type, keyword },
    })
    return res.data
  },

  /// 옵션 상품 상세 조회
  async getOptionProduct(id) {
    const res = await axios.get(`/api/option-products/select/${id}`)
    return res.data
  },

  /// 옵션 상품 등록
  async createOptionProduct({ code, title, subTitle, price, descriptionCode, type, maxCount }) {
    const res = await axios.post("/api/option-products/insert", {
      code,
      title,
      subTitle,
      price,
      descriptionCode,
      type,
      maxCount,
    })
    return res.data
  },

  /// 옵션 상품 수정
  async updateOptionProduct(id, { title, subTitle, price, descriptionCode, type, maxCount }) {
    const res = await axios.put(`/api/option-products/update/${id}`, {
      title,
      subTitle,
      price,
      descriptionCode,
      type,
      maxCount,
    })
    return res.data
  },

  /// 옵션 상품 삭제
  async deleteOptionProduct(id) {
    const res = await axios.delete(`/api/option-products/delete/${id}`)
    return res.data
  },

  /// 옵션 상품 코드 중복 확인
  async checkDuplicateCode(code, excludeId = null) {
    const params = { code }
    if (excludeId) {
      params.excludeId = excludeId
    }
    const res = await axios.get("/api/option-products/select/check-code", { params })
    return res.data
  },

  /// ID 배열로 옵션 상품 목록 조회
  async getOptionProductsByIds(ids) {
    if (!ids || ids.length === 0) {
      return []
    }
    const res = await axios.post("/api/option-products/select/by-ids", { ids })
    return res.data
  },

  /// 옵션 상품 ID 문자열을 파싱하여 상품 정보 조회
  async getOptionProductsByIdString(idString) {
    if (!idString || idString.trim() === "") {
      return []
    }

    // "1,2,3" 형태의 문자열을 숫자 배열로 변환
    const ids = idString
      .split(",")
      .map((id) => parseInt(id.trim()))
      .filter((id) => !isNaN(id))

    if (ids.length === 0) {
      return []
    }

    return this.getOptionProductsByIds(ids)
  },
}
